"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mongiuffi-melia": {
    "246d82fa": [{
      "hkey": "74aeaca1",
      "slug": "mongiuffi",
      "name": "Mongiuffi",
      "primary": true,
      "skipSearch": false
    }],
    "centri-mongiuffi": [{
      "hkey": "74aeaca1",
      "slug": "mongiuffi",
      "name": "Mongiuffi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ba43dd5d": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "skipSearch": false
    }],
    "deri": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c96e5887": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "skipSearch": false
    }],
    "fanaca": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e3317e6c": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "skipSearch": false
    }],
    "incenzo": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a18b1a71": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "skipSearch": false
    }],
    "olivarella": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69e04a89": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "skipSearch": false
    }],
    "san-teodoro": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aff1b477": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "skipSearch": false
    }],
    "saracena": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cbef5c52": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "skipSearch": false
    }],
    "volo": [{
      "hkey": "ec3f2e21",
      "slug": "mongiuffi-melia",
      "name": "Mongiuffi Melia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;